import { Component, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faHeart,
  faSearch,
  faShoppingBag,
  faUserCircle,
  faCoffee,
} from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { NavlinkComponent } from '../navlink/navlink.component';
import { RouterModule } from '@angular/router';
import { SearchComponent } from '../search/search.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    TranslateModule,
    FontAwesomeModule,
    CommonModule,
    NavlinkComponent,
    RouterModule,
    SearchComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  faHeart = faHeart;
  faSearch = faSearch;
  faShoppingBag = faShoppingBag;
  faUserCircle = faUserCircle;
  faCoffee = faCoffee;

  isSearchVisible = false;

  showSearch() {
    this.isSearchVisible = true;
  }

  hideSearch() {
    this.isSearchVisible = false;
  }

  language: string = localStorage.getItem('locale') || 'en'; // Get the stored language or default to English
  currentFlag: string = 'assets/img/oman.png'; // Default flag
  private lastScrollTop = 0;
  private readonly SCROLL_THRESHOLD = 50; // Adjust this value as needed
  private headerVisible = true;

  constructor(
    private translate: TranslateService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    const storedLang = localStorage.getItem('locale') || 'ar'; // Default to Arabic
    this.currentFlag =
      storedLang === 'en' ? 'assets/img/uk.png' : 'assets/img/oman.png'; // Set flag based on locale
  }

  // Method to change language
  changeLanguage(lang: string) {
    localStorage.setItem('locale', lang); // Save the selected language
    this.translate.use(lang); // Change the translation language
    window.location.reload(); // Reload the page to update the language and direction globally
  }

  switchLanguage() {
    // Toggle between English and Arabic
    const currentLang = localStorage.getItem('locale');

    if (currentLang === 'en') {
      this.switchToArabic();
    } else {
      this.switchToEnglish();
    }
  }

  switchToEnglish() {
    // Set language to English
    this.translate.use('en');
    localStorage.setItem('locale', 'en'); // Store the language preference

    // Change flag to UK flag
    this.currentFlag = 'assets/img/uk.png';

    // Refresh the page to apply the language change
    window.location.reload();
  }

  switchToArabic() {
    // Set language to Arabic
    this.translate.use('ar');
    localStorage.setItem('locale', 'ar'); // Store the language preference

    // Change flag to Arabic flag
    this.currentFlag = 'assets/img/oman.png';

    // Refresh the page to apply the language change
    window.location.reload();
  }

  // Hide the header when scrolling down and show it when scrolling up
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const currentScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop > this.SCROLL_THRESHOLD) {
      if (currentScrollTop > this.lastScrollTop) {
        this.hideHeader();
      } else {
        this.showHeader();
      }
    } else {
      this.showHeader();
    }

    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  private hideHeader() {
    if (this.headerVisible) {
      this.renderer.removeClass(
        this.el.nativeElement.querySelector('header'),
        'header-visible'
      );
      this.renderer.addClass(
        this.el.nativeElement.querySelector('header'),
        'header-hidden'
      );
      this.headerVisible = false;
    }
  }

  private showHeader() {
    if (!this.headerVisible) {
      this.renderer.removeClass(
        this.el.nativeElement.querySelector('header'),
        'header-hidden'
      );
      this.renderer.addClass(
        this.el.nativeElement.querySelector('header'),
        'header-visible'
      );
      this.headerVisible = true;
    }
  }
}
